import { addGTMEvent } from 'api/googleTagManager'
import config from 'constants/config'

export const getExperimentValue = (experimentId: string) => new Promise((resolve, reject) => {
  if (typeof window === 'undefined') {
    return reject(null)
  }

  if (experimentId?.startsWith('ENABLE:')) {
    resolve(experimentId.split(':')[1])
    return
  }

  gtag('event', 'optimize.callback', {
    name: experimentId,
    callback: (value) => resolve(value),
  })
})

export const setExperimentValue = (experimentId: string, variant: string) => {
  if (typeof window === 'undefined') {
    return
  }

  if (config.GA_PROPERTY_ID) {
    addGTMEvent({
      event: 'experiment_impression',
      experiment: {
        experimentId,
        variantId: `${experimentId}.${variant}`,
      },
    })
  }
}

// For pushing an event to be used as a trigger to launch an experiment
const getEventWithPrefix = (eventName: EXPERIMENT) => `optimize.${eventName}`

export const isExperimentActivated = (eventName: EXPERIMENT) => {
  if (typeof window === 'undefined') {
    return false
  }
  const eventWithPrefix = getEventWithPrefix(eventName)
  window.dataLayer = window.dataLayer || []
  return dataLayer.find(({ event }) => event === eventWithPrefix)
}

export const startExperiment = (eventName: EXPERIMENT) => {
  if (typeof window === 'undefined') {
    return
  }
  const eventWithPrefix = getEventWithPrefix(eventName)
  window.dataLayer = window.dataLayer || []
  const experimentTriggered = isExperimentActivated(eventName)
  if (!experimentTriggered) {
    dataLayer.push({ event: eventWithPrefix })
  }
}

export enum EXPERIMENT {
  USER_REVIEWS = 'userreviews',
  SERVICE_FEE = 'serviceFee',
  FLIGHT_SESSION_COUNTDOWN_CLOCK = 'flight-session-countdown-clock-experiment',
  STANDALONE_FLIGHTS_CHECKOUT = 'standalone-flights-checkout',
  MOBILE_REGISTRATION = 'mobile-registration',
  INSURANCE_UNSELECTED_BY_DEFAULT = 'unselected-insurance',
  LERE_ON_SCROLL_HOTEL_SRP_STICKY_FOOTER = 'lere-on-scroll-hotel-srp-sticky-footer',
  LERE_ON_IDLE_HOTEL_SRP_STICKY_FOOTER = 'lere-on-idle-hotel-srp-sticky-footer',
  FORCED_LOGIN_VARIANT = 'forced-login-variant',
  PAY_IN_INSTALMENTS = 'pay-in-instalments',
  EXPECTED_VALUE_SORT = 'expected-value-sort',
  PROPERTY_SEARCH_TO_OFFER_PAGE = 'property-to-offer-page',
  ANYWHERE_SEARCH_FILTERS = 'anywhere-search-filters',
  AB_TEST_RESERVE_FOR_ZERO = 'reserve-for-zero',
  TRENDING_DESTINATIONS_PERCENTILE = 'trending-destinations-percentile',
  TRENDING_DESTINATION_BY_SALES = 'trending-destination-by-sales',
  CURATED_TRIP_OFFER_PAGE_PROMO_BANNER = 'curated-trip-offer-page-promo-banner',
  CURATED_TRIP_HOTEL_SEARCH_PAGE_PROMO_BANNER = 'curated-trip-hotel-search-page-promo-banner',
  CRUISES_PRICES_PER_NIGHT = 'cruises-prices-per-night',
  MAP_POSITION = 'map-position',
  OFFER_PAGE_SUPPORT_IMAGE= 'offer-page-support-image',
  CHECKOUT_PAGE_SUPPORT_IMAGE= 'checkout-page-support-image',
  HOME_PAGE_LOADED = 'home-page-loaded',
  OFFER_PAGE_LOADED = 'offer-page-loaded',
  CHECKOUT_PAGE_LOADED = 'checkout-page-loaded',
  REVIEW_V3_PAGE_LOADED = 'review-v3-page-loaded',
  SEARCH_URGENCY_BANNER = 'search-urgency-banner'
}
